'use strict';

var processingResult = require('./api/processingResult.cjs.js');
var conversion = require('./conversion.cjs.js');
var parse = require('./processing/parse.cjs.js');
var catalogService = require('./catalogService.cjs.js');



exports.processingResult = processingResult.processingResult;
exports.locationSpecToLocationEntity = conversion.locationSpecToLocationEntity;
exports.locationSpecToMetadataName = conversion.locationSpecToMetadataName;
exports.parseEntityYaml = parse.parseEntityYaml;
exports.catalogServiceRef = catalogService.catalogServiceRef;
//# sourceMappingURL=index.cjs.js.map
